(() => {
  'use strict';
  if (window.slatplatCartReady) return;
  window.slatplatCartReady=true;
  const fees={"polyester05":56957107700098,"greencoat06":56957107732866,"galfan06":56957107765634,"aluzink06":56957107798402,"zinkmagnesium06":56957107831170,"galv07":56957107863938,"galv09":56957107896706,"galv125":56957107929474,"galv150":56957107962242,"perforerad07":56957107995010,"rostfri07":56957108027778,"rostfri10":56957108060546,"aluminium07_1000":56957108093314,"aluminium07_1230":56957108126082,"aluminium10":56957108158850,"aluminium150":56957108191618,"durk20_40":56957108224386};
  const feeIds=new Set(Object.values(fees));
  const base=window.Shopify?.routes?.root||'/';
  const originalFetch=window.fetch.bind(window);
  let queue=Promise.resolve();
  async function request(path,body) {
    const response=await originalFetch(base+path,body?{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body),signal:AbortSignal.timeout(12000)}:{signal:AbortSignal.timeout(12000)});
    if(!response.ok)throw new Error('Avgiften kunde inte uppdateras.');
    return response.json();
  }
  async function reconcile() {
    let cart=await request('cart.js');
    const wanted=new Set(cart.items.filter(i=>i.product_id===15158722822530).map(i=>fees[i.properties?.Plåttyp]).filter(Boolean));
    const seen=new Set(),updates={};
    for(const item of cart.items) {
      if(!feeIds.has(item.variant_id))continue;
      const quantity=wanted.has(item.variant_id)&&!seen.has(item.variant_id)?1:0;
      seen.add(item.variant_id);
      if(item.quantity!==quantity)updates[item.key]=quantity;
    }
    let changed=Object.keys(updates).length>0;
    if(changed)cart=await request('cart/update.js',{updates});
    const missing=[...wanted].filter(id=>!seen.has(id));
    if(missing.length) {
      await request('cart/add.js',{items:missing.map(id=>({id,quantity:1}))});
      cart=await request('cart.js');changed=true;
    }
    return {cart,changed};
  }
  function sync() {
    const result=queue.then(reconcile);
    queue=result.catch(()=>{});
    return result;
  }
  window.slatplatReconcile = sync;
  window.fetch=async function(input,init) {
    const response=await originalFetch(input,init);
    const url=typeof input==='string'?input:input.url;
    if(response.ok&&/\/cart\/(change|update)(\.js)?(?:\?|$)/.test(url)&&String(init?.method||input?.method||'GET').toUpperCase()==='POST') {
      const {cart,changed}=await sync();
      if(changed)return new Response(JSON.stringify(cart),{status:200,headers:{'Content-Type':'application/json'}});
    }
    return response;
  };
  function start() {
    sync().then(({changed})=>{
      if(!changed)return;
      if(location.pathname.replace(/\/$/,'').endsWith('/cart'))location.reload();
      else if(typeof window.CartDrop==='function')window.CartDrop(true);
    }).catch(error=>console.error('[Slätplåt]',error.message));
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();

